<template>

<core-modal v-on:close="onClose" :nopadding="true" :icon="(data.direct) ? false : 'caret-left'">

	<template v-slot:head>

		{{ index.name }}

	</template>

	<template v-slot:default>

        <div class="index">

            <div class="index-title">Description</div>
            <div class="index-description">{{ index.description }}</div>

            <div class="index-title">Created by</div>
            <div class="index-author">@{{ index.author }}</div>

            <div class="index-title">Type</div>
            <div class="index-author" v-if="index.public">Community</div>
            <div class="index-author" v-if="!index.public">User Only</div>

            <template v-if="index.public">

                <div class="index-title">Users Tracking</div>
                <div class="index-users">{{ index.users }} user<template v-if="index.users != 1">s</template></div>

            </template>

        </div>

        <div class="message" v-if="!isTracking && loggedin">
        
            <template v-if="atLimit">You have hit your limit of {{ limit - 1 }} additional indexes on your insights.<br/>
            <br/>You must remove an index to add a new one.</template>
            
            <template v-if="!atLimit">
            You are not currently tracking this index. Would you like to add it to your insights? 
            <br/><br/>You can add {{ remaining }} more index<template v-if="remaining > 1">es</template> to your insights.</template>
            
        </div>
        
        <div class="message" v-if="isTracking && !isLocked && !isOwn && loggedin">You are currently tracking this index. Would you like to remove it from your insights?</div>

        <div class="message" v-if="isTracking && isLocked && loggedin">You cannot remove this index as it is the system H-index for your profile.<br/><br/>You can add {{ remaining }} more index<template v-if="remaining > 1">es</template> to your insights.</div>

	</template>

	<template v-slot:foot>

		<core-button v-if="canEdit" theme="blue" v-on:click.native="onEditClick">Edit Index</core-button>
		<core-button v-if="!isTracking" theme="blue" v-on:click.native="onTrackClick" :loading="is.loading" :disabled="is.loading">Add to Insights</core-button>
		<core-button v-if="isTracking && !isLocked && index.public" theme="red" v-on:click.native="onUntrackClick" :loading="is.loading" :disabled="is.loading">Remove from Insights</core-button>
        <core-button v-if="isTracking && !isLocked && !index.public" theme="red" v-on:click.native="onUntrackClick" :loading="is.loading" :disabled="is.loading">Permanently Delete</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

    computed: {

		canEdit: function() {

			if(!this.loggedin) return false

			return this.index.user === this.$store.getters['session/user/id']

		},

        isUpgraded: function() {

			return this.$store.getters['session/upgraded']

		},

        isLocked: function() {

            return this.index.id === '1'

        },

        isTracking: function() {

            return this.$_.contains(this.$store.getters['page/insights/hindex/indexes'].tracking, this.index.id);

        },

        atLimit: function() {

            return this.remaining <= 0

        },

        limit: function() {

            return this.$store.getters['session/user'].hindex.limit

        },

        remaining: function() {

            return this.$store.getters['session/user'].hindex.remaining

        },

        isOwn: function() {

            return true

        },

        index: function() {

			return this.data.index

		}

    },

	methods: {

        onEditClick: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'hindexCreate',
                index: this.index
			})

        },

		onTrackClick: function() {

            this.is.loading = true

            this.$api.post('hindex/track', {
                index: this.index.id
            }).then(function(response) {

                this.$store.commit('page/insights/hindex/indexes/index', response.index)
                this.$store.commit('page/insights/hindex/indexes/tracking', response.tracking)
                this.$store.commit('session/user/hindex', response.hindex)
                this.$store.commit('context/hindex', response.hindex)

                this.onClose()

            }.bind(this))

		},

		onUntrackClick: function() {

            this.is.loading = true

            this.$api.post('hindex/untrack', {
                index: this.index.id
            }).then(function(response) {

                if (response.index.slug === this.$route.params.index) {

                    this.$routerPush({
                        name: 'InsightsHindex'
                    })

                }

                this.$store.commit('page/insights/hindex/indexes/index', response.index)
                this.$store.commit('page/insights/hindex/indexes/tracking', response.tracking)
                this.$store.commit('session/user/hindex', response.hindex)
                this.$store.commit('context/hindex', response.hindex)

                this.onClose()

            }.bind(this))

		},

		onClose: function() {

			this.$emit('close')
			if (!this.data.direct) this.$pubsub.$emit('open.modal', 'hindexBrowse')

		}

	}

}

</script>

<style scoped>

.index {
    padding: 20px;
}

.index-name {
    font-weight: 700;
    color: #fff;
    font-size: 16px;
}

.index-title {
    font-weight: 300;
    color: #fff;
    font-size: 14px;
    margin-bottom: 4px;
}

.index-description {
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
    margin-bottom: 20px;
}

.index-author {
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
    margin-bottom: 20px;
}

.index-users {
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
}

.index-foot {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
}

.message {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    font-weight: 400;
    background-color: #254b5f;
    border-radius: 10px;
    padding: 20px;
    margin: 0px 20px;
}

</style>